import { render, staticRenderFns } from "./all-providers.vue?vue&type=template&id=c4aaf83a"
import script from "./all-providers.vue?vue&type=script&lang=js"
export * from "./all-providers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports